import { AlertTriangle } from "lucide-react";
import type { SimulationBottleneck } from "@/types/simulations.types";

interface BottleneckCardProps {
  bottleneck?: SimulationBottleneck;
}

// Gargalo por máquina + nota de limitação do modelo
// (processos independentes, sem fila acoplada). Degradação elegante se ausente.
export function BottleneckCard({ bottleneck }: BottleneckCardProps) {
  if (!bottleneck || bottleneck.machineNames.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">Gargalo não emitido para esta simulação.</p>
    );
  }
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-rd-warning-500" />
        <span className="font-medium">{bottleneck.machineNames.join(", ")}</span>
        <span className="font-mono text-xs text-muted-foreground">
          {bottleneck.effectiveThroughputUnH.toFixed(1)} un/h
        </span>
      </div>
      <p className="text-xs text-muted-foreground">{bottleneck.note}</p>
    </div>
  );
}
